module.exports = __webpack_public_path__ + "static/media/nianhui.7f2c95f2.jpg";